export default "__VITE_ASSET__fAKgR7kY__"